// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Col, Modal, Row, Typography } from 'antd';

// Misc Imports
import { useUpdateBotMutation } from '../../store/bots/botsApi';

const BotDisabledModalWarning = ({
  isModalOpen,
  closeModal,
  handleSave
}) => {
  const { t } = useTranslation();
  const [{ isLoading: isUpdatingBot }] = useUpdateBotMutation({ fixedCacheKey: `updateTenantSettings` });

  return (
    <Modal
      open={isModalOpen}
      centered
      footer={
        <Row gutter={8} justify="end">
          <Col>
            <Button
              size="large"
              onClick={closeModal}
              disabled={isUpdatingBot}
              block
            >
              {t('Back')}
            </Button>
          </Col>

          <Col>
            <Button
              size="large"
              loading={isUpdatingBot}
              onClick={handleSave}
              type="primary"
              block
            >
              {t('Save')}
            </Button>
          </Col>
        </Row>
      }
      closeIcon={<Fragment/>}
      forceRender
      title={t('Change Agent Availability?')}
    >
      <Typography.Text className="fs-lg">
        {t('You have changed agent availability, do you want to proceed?')}
      </Typography.Text>
    </Modal>
  );
};

BotDisabledModalWarning.propTypes = {
  isModalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  deleteBot: PropTypes.func,
  handleSave: PropTypes.func
};
export default BotDisabledModalWarning;
